/**
 * Buduje treść pliku CSV z przygotowanych tabel (jak przy pobieraniu z DownloadSection).
 * @param {Array} tables — wynik prepareUDTable / prepareAZZKUTable itd.
 * @param {string} module — "UD" | "AZZKU" | ...
 */
export function buildPreparedTablesCsvString(tables, module) {
   const parseUdValue = (val) => {
      if (val === null || val === undefined || val === "b/d") {
         return { pct: "b/d", count: "b/d" };
      }
      const str = String(val).trim();
      const match = str.match(/^(-?\d+(?:\.\d+)?)%\s*\(([^)]+)\)$/);
      if (match) {
         const pct = Number(match[1]);
         const countRaw = match[2];
         const countNum = Number(countRaw);
         return {
            pct: Number.isNaN(pct) ? match[1] : pct,
            count: Number.isNaN(countNum) ? countRaw : countNum
         };
      }
      return { pct: str, count: "" };
   };

   const udCsvBaseName = (col, idx) => col.name || `col${idx}`;

   const udCsvHeaderPair = (col, idx) => {
      const rawLabel = col.label != null ? String(col.label).trim() : "";
      const isSum = col.name === "sum";
      const isCombinedPercentN =
         col.name === "count" || /^%\s*\(\s*n\s*\)$/i.test(rawLabel);

      if (isCombinedPercentN) return { pctHeader: "%", countHeader: "n" };
      if (isSum) return { pctHeader: "Suma %", countHeader: "Suma n" };
      const seriesLabel = rawLabel || `Seria ${idx + 1}`;
      return { pctHeader: `${seriesLabel} %`, countHeader: `${seriesLabel} n` };
   };

   const buildUdCsvTable = (table) => {
      if (!table || !table.columns || !table.data) return table;

      const csvColumns = [];
      const csvData = [];
      const labelCol = table.columns[0];
      csvColumns.push({ name: "label", label: labelCol?.label || " " });

      const dataColumns = table.columns.slice(1);

      dataColumns.forEach((col, idx) => {
         const baseName = udCsvBaseName(col, idx);
         const { pctHeader, countHeader } = udCsvHeaderPair(col, idx);
         csvColumns.push({ name: `${baseName}-pct`, label: pctHeader });
         csvColumns.push({ name: `${baseName}-count`, label: countHeader });
      });

      table.data.forEach((row) => {
         const out = { label: row.label };
         dataColumns.forEach((col, idx) => {
            const baseName = udCsvBaseName(col, idx);
            const parsed = parseUdValue(row[col.name]);
            out[`${baseName}-pct`] = parsed.pct;
            out[`${baseName}-count`] = parsed.count;
         });
         csvData.push(out);
      });

      let csvFooter = null;
      if (Array.isArray(table.footer) && table.footer.length) {
         const parsed = parseUdValue(table.footer[1]);
         csvFooter = [table.footer[0], parsed.pct, parsed.count];
      }

      return { ...table, columns: csvColumns, data: csvData, footer: csvFooter };
   };

   const csv_data = ["\uFEFF"];
   const effectiveTables = module === "UD" ? tables.map(buildUdCsvTable) : tables;

   effectiveTables.forEach(({ heading, columns, data, footer }, i) => {
      if (heading && typeof heading === "string") {
         heading
            .split("|")
            .map((h) => h.trim())
            .filter(Boolean)
            .forEach((line) => csv_data.push(line));
      }

      csv_data.push(columns.map((col) => col.label).join(";"));

      data.forEach((item) => {
         csv_data.push(columns.map((col) => item[col.name]).join(";"));
      });

      if (footer && Array.isArray(footer) && footer.length > 0) {
         csv_data.push(footer.join(";"));
      }

      if (effectiveTables[i + 1]) csv_data.push(";;");
   });

   return csv_data.join("\n");
}
